import React from 'react'
import './index.css'

const DestinationItem = props => {
  const {destinationDetails} = props
  const {name, imgUrl} = destinationDetails
  return (
    <li className="list-container">
      <img className="image" src={imgUrl} alt={name} />
      <p className="paragraph-name">{name}</p>
    </li>
  )
}
export default DestinationItem
